import { listen, isRightSidebarMessage, isData } from "@sinch/bus";
import { isBoolean } from "@sinch/feature-flags";
import { useFeatureFlag } from "@sinch/feature-flags/react";
import { useEffect, useState } from "react";
import { useIsMobile } from "../hooks/useIsMobile";

export const useRightSidebarHandler = (): boolean => {
  const isMobile = useIsMobile();
  const newTopbar = useFeatureFlag("newTopbar", isBoolean, false) && !isMobile;
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const unsub = listen((message) => {
      if (isData(message)) {
        switch (message.payload.action) {
          case "open":
            setIsOpen(true);
            return;
          case "close":
            setIsOpen(false);
            return;
          default:
            setIsOpen((prevState) => !prevState);
            return;
        }
      }
    }, isRightSidebarMessage);

    return unsub;
  }, []);

  if (!newTopbar) {
    return false;
  }

  return isOpen;
};
